import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';

import { Box, Flex } from 'web-ui-kit/legacy';
import { ADDED_TO_CART_FEEDBACK_MODAL_Z_INDEX } from 'web-ui-kit/zIndexes';

import Confirmation from './Confirmation';
import CompressedProductDetails from './CompressedProductDetails';
import FeedbackActions from './FeedbackActions';

import {
  getLastAddedProduct,
  getShowAddToCartFeedback,
  toggleAddToCartFeedback
} from './state';

import { getFullScreenRenderBool } from 'redux/Studio/DesignViewer';

import CloseIconSVG from 'static/images/studio/icons/close-icon.svg';

const Background = styled(Box)`
  background: rgba(0, 0, 0, 0.5);
  height: 100vh;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: ${ADDED_TO_CART_FEEDBACK_MODAL_Z_INDEX};
  pointer-events: auto;
`;

const Container = styled(Flex)`
  border-top: 0.4px solid #bdbdbd;
  box-sizing: border-box;
  cursor: default;
  padding: 1rem 2rem 1.5rem;
  position: absolute;
  right: ${props => props.right ? props.right : 0};
  top: 0;
  width: 375px;

  @media (max-width: 768px) {
    border: none;
    position: fixed;
    margin-top: 0;
    max-width: 420px;
    width: 100%;
  }
`;

const CloseIcon = styled.img`
  cursor: pointer;
  position: absolute;
  pointer-events: all;
  right: 32px;
  top: 24px;
  height: 14px;
  width: 14px;
`;

export class AddToCartFeedback extends Component {
  constructor (props) {
    super(props);

    this.handleBodyClick = this.handleBodyClick.bind(this);
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.showAddToCartFeedback && this.props.showAddToCartFeedback) {
      document.body.style.overflow = 'hidden';
      document.body.addEventListener('click', this.handleBodyClick);
    } else if (prevProps.showAddToCartFeedback && !this.props.showAddToCartFeedback) {
      document.body.removeEventListener('click', this.handleBodyClick);
      document.body.style.overflow = 'auto';
    }
  }

  componentWillUnmount () {
    document.body.style.overflow = 'auto';
  }

  handleBodyClick (event) {
    if (this.container &&
      this.container !== event.target &&
      !this.container.contains(event.target)) {
      this.props.toggleAddToCartFeedback(null);
      event.stopPropagation && event.stopPropagation();
    }
  }

  renderFeeback () {
    const {
      className,
      designId,
      isShop,
      lastAddedProduct,
      onProceedToCheckout,
      showFullScreenRender,
      spaceId,
      toggleAddToCartFeedback
    } = this.props;

    const cartButton = document.getElementById('nav-cart-button');
    let cartButtonRight = 0;
    if (cartButton) {
      cartButtonRight = window.innerWidth - cartButton.getBoundingClientRect().right + 'px';
    }

    return createPortal(
      <Background className={className} data-testid='atc-feedback'>
        <Container
          bg='#fff'
          column
          ref={el => { this.container = el; }}
          showFullScreenRender={showFullScreenRender}
          id='atc-feedback'
          right={cartButtonRight}
        >
          <CloseIcon onClick={toggleAddToCartFeedback} src={CloseIconSVG} alt='close-icon' />

          <Confirmation />

          <CompressedProductDetails product={lastAddedProduct} />

          <FeedbackActions
            designId={designId}
            spaceId={spaceId}
            onClose={toggleAddToCartFeedback}
            isShop={isShop}
            onProceedToCheckout={onProceedToCheckout}
          />
        </Container>
      </Background>,
      document.body
    );
  }

  render () {
    const {
      showAddToCartFeedback
    } = this.props;

    if (showAddToCartFeedback) {
      return this.renderFeeback();
    }

    return null;
  }
}

const mapStateToProps = state => {
  return {
    lastAddedProduct: getLastAddedProduct(state),
    showAddToCartFeedback: getShowAddToCartFeedback(state),
    showFullScreenRender: getFullScreenRenderBool({ state })
  };
};

const mapDispatchToProps = dispatch => ({
  toggleAddToCartFeedback () {
    dispatch(toggleAddToCartFeedback(null));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AddToCartFeedback);
